import { CommonModule } from '@angular/common';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { PagerComponent } from './pager.component';
import { PageData } from './pager.model';
import { SelectModule } from '../select';

@NgModule({
    declarations: [
        PagerComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        SelectModule,
    ],
    exports : [PagerComponent],
})
export class PagerModule {
    public static forRoot(): ModuleWithProviders {
        return {
            ngModule: PagerModule
        };
    }
}

export { PageData };
